import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { LocalizationService } from '../../shared/services';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { invitePageRegExp } from '../../shared/utilities';
import { SystemPages } from '../../shared/enums/routerPaths.enum';
import { Locale } from '../../shared/models';
import { Localization } from '../../shared/classes';

export const PublicGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const localizationService: LocalizationService = inject(LocalizationService);

  let canActive: boolean = true;
  const isUserLoggedIn: boolean = authService.getIsUserLoggedIn();

  if (isUserLoggedIn) {
    if (isResetPasswordLink(route)) {
      void router.navigate([SystemPages.USER_PROFILE], { queryParams: route.queryParams });
      return false;
    }

    canActive = isAvailableToAll(state);
    const lang: Locale = localizationService.getCurrentLocale(isUserLoggedIn);

    if (!Localization.doesRouteIncludeLang(route, lang)) {
      // If lang param is not present, add it to the route
      const fullPath: string = Localization.getFullPathByState(state, lang);

      void router.navigateByUrl(fullPath);
    } else if (!canActive && state.url.indexOf(`/${lang}`) === 0) {
      const fullPath: string = Localization.getFullPath(SystemPages.SEARCH, lang);
      void router.navigateByUrl(fullPath);
    }
  }

  return canActive;
};

function isAvailableToAll(state: RouterStateSnapshot): boolean {
  const url: string = state.url;

  return isInvitePage(url);
}

function isInvitePage(url: string): boolean {
  return !!url.match(invitePageRegExp);
}

function isResetPasswordLink(route: ActivatedRouteSnapshot): boolean {
  return route.queryParamMap.has('password_key');
}
